export default __webpack_public_path__ + "static/media/product3.26dbf87d.jpg";